export enum PopUpModalType {
  ElectronicSignature = 0,
  AiFirstTimeUse = 1,
  AiTemporarilyUnavailable = 2,
  AiContentFiltering = 3,
  UsageCreditsExceeded = 4,
}
